import React from 'react';
import PropTypes from 'prop-types';
import { FooterContainer, PaymentButtonContainer, ButtonContainer, PaymentButton } from './style';
export var Footer = function Footer(props) {
  return React.createElement(FooterContainer, null, React.createElement(ButtonContainer, {
    two: true
  }, React.createElement(PaymentButtonContainer, null, React.createElement(PaymentButton, {
    onClick: function onClick() {
      return props.handleClick();
    }
  }, props.label))));
};
Footer.propTypes = {
  handleClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string
};